


















import { Component, Vue, PropSync, Watch, Prop } from "vue-property-decorator";
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";
import { PrestadorPaginationModel } from "@/models/cadastros/saude/PrestadorPaginationModel";

@Component({
  inheritAttrs: false,
})
export default class PrestadorAutocomplete extends Vue {
  @PropSync("prestador", { required: true })
  prestadorSynced!: PrestadorResumidoModel | undefined;

  @Prop({default: -1})
  readonly idEspecialidade!: number;

  prestadoresLocalizados: PrestadorResumidoModel[] = [];

  loadingPrestadores = false;
  nomePrestador = "";

  // Utilizado para o debounce manual
  timerPrestador: any = 0;

  @Watch("nomePrestador")
  obterPrestadores(val: string) {
    val = (val || "").trim();
    if (val == "") {
      this.prestadoresLocalizados = [];
      return;
    }

    // se o campo tem menos que 5 caracteres não faz a busca
    if (val.length < 4) return;
    this.loadingPrestadores = true;

    // Debounce manual - LODASH não funcionou
    clearTimeout(this.timerPrestador);
    this.timerPrestador = setTimeout(() => {
      if(this.idEspecialidade && this.idEspecialidade > 0) {
        cadastroPrestadorService.pesquisarPrestadorPorEspecialidadeENome(this.idEspecialidade, val)
        .then((prestadores: PrestadorResumidoModel[]) => {
          this.prestadoresLocalizados = prestadores;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loadingPrestadores = false;
        });
      } else {
        cadastroPrestadorService
          .pesquisarPrestadorPorNome(val)
          .then((prestadores: PrestadorResumidoModel[]) => {
            this.prestadoresLocalizados = prestadores;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.loadingPrestadores = false;
          });
      }
    }, 300);
  }

  get autoCompleteAttrs() {
    const { rules, name, ...attrs } = this.$attrs;
    return attrs;
  }

  get validationAttrs() {
    const { rules, name, ...attrs } = this.$attrs;
    return {
      rules,
      name,
    };
  }
}
